import _ from 'lodash';
import React, { useMemo } from 'react';
import {
  ApprovalStatusFilter,
  ClientApprovalStatusFilter,
  ExpenseBillableTypeFilter,
  ExpenseCategoryFilter,
  ExpenseReimbursableTypeFilter,
  InvoicedFilter,
} from '~/components';
import ReimbursedFilter from '~/components/filters/ReimbursedFilter';
import ExpenseTypeFilter from './ExpenseTypeFilter';
import ReportPeriodFilter from './ReportPeriodFilter';

export default function ExpenseFiltersBar({ filters, sticky, onChange }) {
  const visible = useMemo(() => {
    const isVisible = (key) => sticky?.includes(key) || !_.isEmpty(filters[key]);

    return {
      createdPeriod:
        sticky?.includes('createdPeriod') || Boolean(filters.createdPeriod?.start || filters.createdPeriod?.end),
      modifiedPeriod:
        sticky?.includes('modifiedPeriod') || Boolean(filters.modifiedPeriod?.start || filters.modifiedPeriod?.end),
      expenseApprovalStatuses: isVisible('expenseApprovalStatuses'),
      expenseClientApprovalStatuses: isVisible('expenseClientApprovalStatuses'),
      expenseInvoiced: isVisible('expenseInvoiced'),
      expenseCategories: isVisible('expenseCategories'),
      expenseTypeId: isVisible('expenseTypeId'),
      expenseBillableTypeId: isVisible('expenseBillableTypeId'),
      expenseReimbursableTypeId: isVisible('expenseReimbursableTypeId'),
      expenseIsReimbursed: isVisible('expenseIsReimbursed'),
    };
  }, [filters, sticky]);

  return (
    <>
      {visible.createdPeriod && (
        <ReportPeriodFilter
          placeholder="Created Date Range"
          value={filters.createdPeriod}
          onChange={({ value }) => onChange({ createdPeriod: value })}
        />
      )}

      {visible.modifiedPeriod && (
        <ReportPeriodFilter
          placeholder="Modified Date Range"
          value={filters.modifiedPeriod}
          onChange={({ value }) => onChange({ modifiedPeriod: value })}
        />
      )}

      {visible.expenseApprovalStatuses && (
        <ApprovalStatusFilter
          value={filters.expenseApprovalStatuses}
          onChange={({ target: { value } }) => onChange({ expenseApprovalStatuses: value })}
        />
      )}

      {visible.expenseClientApprovalStatuses && (
        <ClientApprovalStatusFilter
          value={filters.expenseClientApprovalStatuses}
          onChange={({ target: { value } }) => onChange({ expenseClientApprovalStatuses: value })}
        />
      )}

      {visible.expenseInvoiced && (
        <InvoicedFilter
          value={filters.expenseInvoiced}
          onChange={({ target: { value } }) => onChange({ expenseInvoiced: value })}
        />
      )}

      {visible.expenseCategories && (
        <ExpenseCategoryFilter
          value={filters.expenseCategories}
          onChange={({ target: { value } }) => onChange({ expenseCategories: value })}
        />
      )}

      {visible.expenseTypeId && (
        <ExpenseTypeFilter
          value={filters.expenseTypeId}
          onChange={({ target: { value } }) => onChange({ expenseTypeId: value })}
        />
      )}

      {visible.expenseBillableTypeId && (
        <ExpenseBillableTypeFilter
          value={filters.expenseBillableTypeId}
          onChange={({ target: { value } }) => onChange({ expenseBillableTypeId: value })}
        />
      )}

      {visible.expenseReimbursableTypeId && (
        <ExpenseReimbursableTypeFilter
          value={filters.expenseReimbursableTypeId}
          onChange={({ target: { value } }) => onChange({ expenseReimbursableTypeId: value })}
        />
      )}

      {visible.expenseIsReimbursed && (
        <ReimbursedFilter
          value={filters.expenseIsReimbursed}
          onChange={({ target: { value } }) => onChange({ expenseIsReimbursed: value })}
        />
      )}
    </>
  );
}
